import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-template-sms-edit',
  standalone: false,
  templateUrl: './notification-template-sms-edit.component.html',
  styleUrl: './notification-template-sms-edit.component.scss'
})
export class NotificationTemplateSmsEditComponent {

}
